<script setup lang="ts">
// The connection banner (design §6.5), sticky at the top of the shell's main. The
// shell decides when to show each message; this only shows them: "Reconnecting…"
// once the live stream has been down a while, and "Discord is unavailable" while a
// worker is configured but none is connected.
import Banner from './Banner.vue';

defineProps<{ reconnecting: boolean; discordUnavailable: boolean }>();
</script>

<template>
  <div v-if="reconnecting || discordUnavailable" class="itc-connection-banner">
    <Banner v-if="reconnecting" tone="warn"><span>Reconnecting…</span></Banner>
    <Banner v-else tone="crit"><span>Discord is unavailable: changes that need Discord will wait.</span></Banner>
  </div>
</template>

<style scoped>
/* Bleeds to the edges of AppShell's main, whose padding is 20px 24px (16px across on phones). */
.itc-connection-banner {
  position: sticky;
  top: 0;
  z-index: 9;
  margin: -20px -24px var(--itc-s4);
  padding: var(--itc-s2) 24px;
  background: var(--itc-bg);
  border-bottom: 1px solid var(--itc-line);
}
@media (max-width: 720px) {
  .itc-connection-banner {
    margin: -20px -16px var(--itc-s4);
    padding: var(--itc-s2) 16px;
  }
}
</style>
